import { useTheme } from '@/shared/hooks/useTheme';
import { versionedPublicAssetUrl } from '@/shared/lib/publicAssetUrl';

const lightLogoUrl = versionedPublicAssetUrl('sshop-logo-light.png');
const darkLogoUrl = versionedPublicAssetUrl('sshop-logo-dark.png');

const COLORS = ['#0a7db6', '#37b1fa', '#8abd3c', '#fc5c46'] as const;

interface AppLoaderProps {
  readonly label?: string;
}

export function AppLoader({ label = 'Loading…' }: AppLoaderProps) {
  const { resolvedTheme } = useTheme();
  const logoUrl = resolvedTheme === 'dark' ? darkLogoUrl : lightLogoUrl;

  return (
    <div
      className="animate-overlay-in bg-bg-canvas/95 fixed inset-0 z-[1000] flex min-h-[100dvh] items-center justify-center overflow-hidden px-6 backdrop-blur-sm"
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <div className="flex w-full max-w-xs flex-col items-center">
        <img
          src={logoUrl}
          alt="SSHOP.GE"
          className="animate-loader-logo h-auto w-full max-w-[260px] select-none"
          draggable={false}
          decoding="async"
        />
        <div className="mt-7 flex items-center gap-2" aria-hidden>
          {COLORS.map((color, index) => (
            <span
              key={color}
              className="animate-loader-segment h-2 w-9 rounded-[3px]"
              style={{ backgroundColor: color, animationDelay: `${index * 110}ms` }}
            />
          ))}
        </div>
        <span className="text-fg-muted mt-4 text-sm font-medium">{label}</span>
      </div>
    </div>
  );
}
